import { Injectable, inject } from '@angular/core';

import { BaseConfig, SHARED_CONFIG, SharedConfig } from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly sharedConfig = inject<SharedConfig>(SHARED_CONFIG);

  public model: BaseConfig | undefined;

  public get config(): BaseConfig | undefined {
    return this.model;
  }

  public get isLocal() {
    return window.location.hostname.includes('localhost');
  }

  public get identityServerUrl(): string {
    return this.model?.identityServerUrl || '';
  }

  public get applicationName(): string {
    if (this.model?.clientDomains) {
      const clientDomain = this.model.clientDomains.find(x => x.domain === window.location.host);
      if (clientDomain) {
        return clientDomain.client;
      }
    }

    return this.sharedConfig.applicationName;
  }

  public get userPilotToken(): string | undefined {
    return this.model?.userPilotToken;
  }

  public async load(): Promise<unknown> {
    const configResponse = await fetch('assets/config.json');
    this.model = await configResponse.json();
    return this.model;
  }
}
